export default "/images/amex24x24.svg?f037c7723db0e37a4bbc3e17f3c3f816";